<template>
    <router-view id="app" class="flex-fill" />
</template>

<script>
// import Api from "api-client/index";

export default {
  mounted() {
    document.addEventListener("dragstart", this.preventNavTabDrag);
  },
  beforeDestroy() {
    document.removeEventListener("dragstart", this.preventNavTabDrag);
  },
  methods: {
    preventNavTabDrag(event) {
      if (event.target.closest(".nav-tabs .nav-item")) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style>
.height-0 {
  height: 0 !important;
}
</style>

<style lang="scss">
.text-dots {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.horizontal-center {
  width: max-content;
}

.cursor-pointer {
  cursor: pointer;
}

.custom-hover {
  transition: 0.3s;
}

.custom-hover:hover {
  background-color: #efefef;
  border-color: #efefef !important;
}

.vertical-center {
  margin: auto 0;
}

@font-face {
  font-family: "Montserrat";
  src: url(./assets/fonts/Montserrat/montserrat-regular-webfont.eot);
  src: url(./assets/fonts/Montserrat/montserrat-regular-webfont.eot?#iefix)
      format("embedded-opentype"),
    url(./assets/fonts/Montserrat/montserrat-regular-webfont.woff2)
      format("woff2"),
    url(./assets/fonts/Montserrat/montserrat-regular-webfont.woff)
      format("woff"),
    url(./assets/fonts/Montserrat/montserrat-regular-webfont.ttf)
      format("truetype"),
    url(./assets/fonts/Montserrat/montserrat-regular-webfont.svg#montserratregular)
      format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Poppins";
  src: url(./assets/fonts/Poppins/poppins-regular-webfont.eot);
  src: url(./assets/fonts/Poppins/poppins-regular-webfont.eot?#iefix)
      format("embedded-opentype"),
    url(./assets/fonts/Poppins/poppins-regular-webfont.woff2) format("woff2"),
    url(./assets/fonts/Poppins/poppins-regular-webfont.woff) format("woff"),
    url(./assets/fonts/Poppins/poppins-regular-webfont.ttf) format("truetype"),
    url(./assets/fonts/Poppins/poppins-regular-webfont.svg#poppinsregular)
      format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Jumper";
  src: url(./assets/fonts/Jumper/Jumper-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "JumperBold";
  src: url(./assets/fonts/Jumper/Jumper-Bold.ttf) format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "JumperLight";
  src: url(./assets/fonts/Jumper/Jumper-Light.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "JumperThin";
  src: url(./assets/fonts/Jumper/Jumper-Thin.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

//* {
//  font-family: JumperLight;
//  font-weight: 200;
//}

.font-poppins,
.font-poppins * {
  font-family: Poppins !important;
}


.font-jumperthin,
.font-jumperthin * {
  font-family: JumperThin;
}

.font-jumperlight,
.font-jumperlight * {
  font-family: JumperLight;
}

.font-jumperbold,
.font-jumperbold * {
  font-family: JumperBold;
}
.font-jumper,
.font-jumper * {
  font-family: Jumper;
}

html, body {
  background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(239, 243, 244, 1) 100%), #FFF;
}

.custom-card-header-text {
  font-size: 1.15rem;
}

.header-title {
  margin-top: 3px;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 1.25rem;
}

.width-max-content {
  width: max-content;
}

#app a {
  color: #80808f;
}

#app a:hover {
  text-decoration: none;
  color: #b2ec5d;
}

#app input, #app select, .datepicker, .custom-select {
  border-radius: 32px !important;
  background: rgba(174, 191, 199, 0.50) !important;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10) !important;
  font-size: 12px !important;
  padding: 20px !important;
  color: #252734 !important;
  margin-bottom: 10px;
  border-color: #AEBFC7 !important;
}
#app .custom-select {
  padding: 0px 20px !important;
  height: 42px !important;
}

#app .lightInputs input, #app .lightInputs select, .lightInputs .datepicker, .lightInputs .custom-select {
  border-radius: 32px !important;
  background: white !important;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10) !important;
  font-size: 12px !important;
  padding: 20px !important;
  color: #252734 !important;
  border-color: #AEBFC7 !important;
}

.datepicker {
  border: none !important;
  padding: 10px !important;
}

.datepicker .mx-input {
  background-color: transparent !important;
  border: none !important;
}

#app .employee-date-picker {
  min-height: 42px;
  width: 100%;
  background-color: #ffffff !important;
  border-radius: 32px;
  font-family: Poppins, sans-serif;
}

#app .employee-date-picker .mx-input-wrapper {
  height: 42px;
  background-color: #ffffff !important;
  border-radius: 32px;
  font-family: Poppins, sans-serif;
}

#app .employee-date-picker .mx-input {
  height: 42px !important;
  background-color: #ffffff !important;
  font-family: Poppins, sans-serif !important;
}

#app .employee-date-picker .mx-icon-calendar {
  top: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  line-height: 1;
  transform: translateY(-50%) !important;
}

#app .employee-date-picker .mx-icon-calendar svg {
  display: block;
  vertical-align: 0;
}

#app .btn-light {
  color: #5bb65d;
}

#app a.dropdown-item:active {
  background-color: #dedede;
}

#app .card {
  border: 0;

  .card-header {
    background-color: transparent;
    border-bottom: none;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;

    button {
      //width: 130px;
    }
  }

  .card-body {
    padding: 15px;
  }
}

#app .vdpArrowPrev:after {
  border-right-color: #5bb65d;
}

#app .vdpArrowNext:after {
  border-left-color: #5bb65d;
}

#app .vdpCell.selectable:hover .vdpCellContent,
.vdpCell.selected .vdpCellContent {
  background: #5bb65d;
}

#app .vdpCell.today {
  color: #5bb65d;
}

#app .vdpTimeUnit > input:hover,
.vdpTimeUnit > input:focus {
  border-bottom-color: #5bb65d;
}

.is-invalid .mx-input {
  border-color: red;
}

.is-invalid svg {
  color: red;
}

.validation-error-msg {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0rem rgba(0, 0, 0, 0) !important;
}

.btn-primary {
  border-radius: 32px !important;
  border: none !important;
  background: #252734 !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.15);
  color: #B2EC5D !important;
  font-family: Jumper;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 300;
  line-height: 30px !important; /* 125% */
  padding-left: 44px !important;
  padding-right: 44px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.btn-primary:hover {
  background-color: #b2ec5d !important;
  color: #252734 !important;
}

.btn-success {
  border-radius: 32px !important;
  border: none !important;
  background: #B2EC5D !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  color: #252734 !important;
  font-family: Jumper;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 30px !important; /* 125% */
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.btn-success:hover {
  background-color: #252734 !important;
  color: #b2ec5d !important;
}

.btn-danger {
  border-radius: 32px !important;
  border: none !important;
  background: #F88379 !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  color: #252734 !important;
  font-family: Jumper;
  font-size: 18px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 30px !important; /* 125% */
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.btn-danger:hover {
  background-color: #bb675e !important;
}

.btn-light {
  background-color: #b2ec5d !important;
  border: none;
  color: #252734 !important;
  border-radius: 32px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.btn-light:hover {
  background-color: #252734 !important;
  color: #b2ec5d !important;
}

.btn-link {
  color: gray !important;
}

.btn-secondary {
  color: #252734 !important;
  border-radius: 32px !important;
  //border: 1px solid #252734 !important;
  font-family: JumperLight;
  font-size: 18px !important;
  font-style: normal;
  line-height: 30px !important; /* 125% */
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  padding-left: 30px;
  padding-right: 30px;
  background-color: transparent !important;
}

.card {
  border-radius: 32px;
  background: #AEBFC7;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  padding: 15px;
}

.custom-card-header-text {
  font-family: Jumper !important;
}

.list-item {
  border-radius: 32px !important;
  border: 1px solid #252734 !important;
  font-family: Jumper !important;
}

.btn-sm {
  font-size: 14px !important;
  padding-left: 20px !important;
  padding-right: 28px !important;
  font-family: Jumper !important;
}

.modal-backdrop {
  background: rgba(174, 192, 198, 0.60) !important;
}

.modal-content {
  border-radius: 32px !important;
  border: none;
  background-color: #FFF;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10);
  font-family: Jumper !important;
  padding: 10px !important;
}

.modal-header {
  background-color: transparent;
  border: none !important;
}

.modal-title {
  text-align: left !important;
  font-family: Jumper !important;
}

.nav-tabs, .btn-group {
  background-color: #252734;
  border-radius: 32px;
  border: 5px solid #252734;
  display: inline-flex;
}

.nav-link, .btn-group button {
  color: white !important;
  border: none !important;
  border-radius: 22px !important;
  font-family: JumperThin !important;
  font-size: 16px !important;
  line-height: normal !important;
}

.nav-link:hover, .btn-group button:hover {
  color: #b2ec5d !important;
}

.nav-link.active, .btn-group button.btn-active {
  background-color: #b2ec5d !important;
  color: #252734 !important;
}

.text-success {
  color: #b2ec5d !important;
}

.main-wrapper {
  background-color: transparent !important;
}

.customTable {
  border-spacing: 0 10px !important;
  width: 100% !important;
  border-collapse:separate;
}

.customTable thead {
  font-size: 12px !important;
}

.customTable tr td {
  background-color: #AEBFC7 !important;
  padding: 20px !important;
  font-family: JumperThin !important;
}

.customTable tr td:first-child {
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
}

.customTable tr td:last-child {
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before, .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #b2ec5d;
  border-color: #b2ec5d;
}

.custom-radio .custom-control-input ~ .custom-control-label::before, .custom-checkbox .custom-control-input ~ .custom-control-label::before {
  background-color: #fff;
  border-color: #ccc;
  border-radius: 32px;
}

.custom-radio .custom-control-input:focus ~ .custom-control-label::before, .custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}

#app .uploaderSelect input {
  padding: 15px !important;
  height: 40px !important;
}

#app .selection {
  padding-top: 15px !important;
  padding-left: 20px !important;
  font-size: 12px !important;
}


@media (max-width: 768px) {
  .toast-bottom-right {
    right: 12px !important;
    bottom: 48px !important;
  }
  .custom-card-header-text {
    font-size: 1.5rem;
  }
  .header-title {
    font-size: 1.75rem;
  }
  .router-content {
    padding: 20px !important;
    padding-bottom: 130px !important;
  }
  .d-flex.justify-content-start {
    flex-direction: column !important;
  }
  .nav-tabs {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .nav-item {
    flex: 0 0 auto;
  }
  .reportSliderContainer * {
    font-size: 20px !important;
  }
  .disableClickOnMobile {
    pointer-events: none !important;
  }
}

.nav-tabs {
  display: flex;
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.nav-tabs::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.nav-tabs li {
  margin: 0px !important;
}

.nav-tabs .nav-item,
.nav-tabs .nav-link {
  -webkit-user-drag: none;
  user-select: none;
}

.ui.selection.dropdown {
  border: none !important;
}

.detailsSelect input.search {
  height: 22px !important;
}

.router-link-exact-active {
  background-color: transparent !important;
}
#company-hasAccountant-input + label::before {
  border: 1px solid #252734 !important;
}
#company-hasAccountant-input:checked + label::before {
  background-color: #252734 !important;
}

#app .white-input, #app .white-input * {
  background-color: white !important;
  border-radius: 32px !important;
  border-color: #AEBFC7 !important;
}

#app .invisible-input, #app .invisible-input * {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  padding: 0px !important;
  margin: 0px !important;
  font-size: 16px !important;
}

#app .mx-datepicker-popup {
  border-radius: 32px !important;
}

#app .uploaderSelect input {
  border: 1px solid #AEBFC7 !important;
  padding-top: 10px !important;
}

#app i.dropdown.icon {
  background-color: transparent !important;
  color: #AEBFC7;
  font-family: "Font Awesome 6 Pro" !important;
  font-weight: 900;
}

#app i.dropdown.icon:before {
  content: '\f078' !important; /* Font Awesome chevron-down icon */
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
}

#app .dropdown .menu {
  margin-top: 10px !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 20px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.rounded-lg {
  border-radius: 32px !important;
}

#app .selection.uploader-select input {
  background-color: white !important;
  border: 1px solid #AEC0C7 !important;
}
#app .selection.uploader-select {
  padding-top: 5px !important;
  margin-top: -10px !important;
}
</style>
